import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTicketOutlinedCampaign = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Icon / TicketOutlined",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M20.25 20.5H3.75C2.23108 20.5 1 19.2689 1 17.75V14.1548L2.00467 14.1576C3.013 14.131 3.82517 13.3023 3.82517 12.2876C3.82517 11.2728 3.01483 10.446 2.00833 10.4176L1 10.4203V6.75C1 5.23108 2.23108 4 3.75 4H20.25C21.7689 4 23 5.23108 23 6.75V10.4167H22.186C21.2721 10.4167 20.4242 11.0391 20.2757 11.9402C20.0868 13.0878 20.9705 14.0833 22.0833 14.0833H23V17.75C23 19.2689 21.7689 20.5 20.25 20.5ZM3.75 18.6667H20.25C20.756 18.6667 21.1667 18.256 21.1667 17.75V15.8012C19.5873 15.3932 18.4167 13.9559 18.4167 12.25C18.4167 10.5441 19.5873 9.10767 21.1667 8.69883V6.75C21.1667 6.244 20.756 5.83333 20.25 5.83333H3.75C3.244 5.83333 2.83333 6.244 2.83333 6.75V8.68875C4.45308 9.08475 5.6585 10.5478 5.6585 12.2876C5.6585 14.0274 4.45308 15.4904 2.83333 15.8864V17.75C2.83333 18.256 3.244 18.6667 3.75 18.6667Z",
			fill: "white"
		})
	})]
});
const ForwardRef = forwardRef(SvgTicketOutlinedCampaign);
export default ForwardRef;
